import React from 'react';
import PropTypes from 'prop-types';

import createStyle from 'shared-utils/src/createStyle';

import TrashIcon from 'shared-vectors/icons/Trash';
import { Icon } from 'shared-vectors';

import Grid from '../../../../Grid';

import style, { mainCls } from './style';

const useStyles = createStyle(style);

const DeleteBookmark = ({
  deleteBookmarkFn,
}) => {
  const cls = useStyles();
  return (
    <Grid
      className={`${cls[mainCls]} pt--ml`}
    >
      <button
        type="button"
        className={`${cls[`${mainCls}__btn`]} is-clickable tp-s--s tp-w--m c-txt--secondary`}
        onClick={deleteBookmarkFn}
      >
        <Icon
          name={TrashIcon}
          className="mr--xs"
        />
        Elimina dai preferiti
      </button>
    </Grid>
  );
};

export default DeleteBookmark;

DeleteBookmark.propTypes = {
  deleteBookmarkFn: PropTypes.func,
};
DeleteBookmark.defaultProps = {
  deleteBookmarkFn: () => {},
};